import {DualAxes, DualAxesConfig} from '@ant-design/charts'
import {Meta} from '@antv/g2plot'

import {ChartDataProps, DailyTwoValueChartData} from '../../../model/chart'
import {dailyGarminStepTheme} from '../theme/daily_garmin_step_theme'
import {ChartCard} from '../template/chart_card'
import {defaultDailyChartXAxisConfig} from '../../../lib/chart_data/util/formatter'

export const GarminDailySummaryStepWithGoalChart = (props: ChartDataProps<DailyTwoValueChartData>) => {
  const {height, width, title, data} = props
  const xField: keyof DailyTwoValueChartData = 'yymmdd'
  const yField: (keyof DailyTwoValueChartData)[] = ['value', 'value2']
  const meta: {[key in keyof DailyTwoValueChartData]: Meta} = {
    yymmdd: {
      alias: 'Date',
    },
    value: {
      alias: 'Total steps',
    },
    value2: {
      alias: 'Steps goal',
    },
  }

  let maxStepOrGoalValue = 0
  for (const {value, value2} of data) {
    if (value && value > maxStepOrGoalValue) {
      maxStepOrGoalValue = value
    }
    if (value2 && value2 > maxStepOrGoalValue) {
      maxStepOrGoalValue = value2
    }
  }

  const yAxisConfig = {
    title: {text: 'Total steps'},
    min: 0,
    max: maxStepOrGoalValue,
  }

  const yAxisConfigForValue2 = {
    title: {text: 'Steps goal'},
    min: 0,
    max: maxStepOrGoalValue,
  }

  const config: DualAxesConfig = {
    data: [data, data],
    autoFit: true,
    theme: dailyGarminStepTheme,
    legend: {position: 'bottom-right'},
    xField,
    yField,
    xAxis: defaultDailyChartXAxisConfig,
    yAxis: [yAxisConfig, yAxisConfigForValue2],
    meta,
    geometryOptions: [
      {
        geometry: 'column',
      },
      {
        geometry: 'line',
        point: {},
        lineStyle: {
          lineWidth: 2,
        },
      },
    ],
  }

  const chartCardProps = {
    height: height,
    width: width,
    chartTitle: title ?? 'Garmin Connect Steps',
    hintDescription: '',
    chart: <DualAxes {...config} />,
  }
  return <ChartCard {...chartCardProps} />
}
